import NavigationBar from "../../../navigation_components/NavigationBar";
import TenantAdministratorSideBar from "../../../sidebar_components/TenantAdministratorSideBar";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/HomePage/HomePage.css";
import { useEffect } from "react";

const HomePage = () =>{
    useEffect(() =>{
        document.title = 'Home';
    },[]);
    return(
        <div className="tenant-admin-home-page">
            <NavigationBar/>
            <div className="tenant-admin-home-page-layout">
                <div>
                    <TenantAdministratorSideBar/>
                </div>
                <div className="tenant-admin-home-page-parent-container">
                    <div className="tenant-admin-home-page-container">
                        <p>Tenant administrator Home Page coming soon</p>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default HomePage;